var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257.723,
    height: 277.93,
    viewBox: "0 0 257.723 277.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2f2e41;}.b{fill:#ffb8b8;}.c{fill:#6c63ff;}.d{fill:#3f3d56;}.e{opacity:0.3;isolation:isolate;}.f{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1211.486 -12080.716)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M789.435,353.265V340.606a16.861,16.861,0,1,0-33.722,0v12.659a2.274,2.274,0,0,0,2.265,2.279H787.17a2.274,2.274,0,0,0,2.265-2.279Z",
    transform: "translate(522.239 11829.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M563.462,514.289l5.947,1.656,9.178-22.289-8.777-2.444Z",
    transform: "translate(706.418 11833.313)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.508,7.546l11.905.018L19.4.03,0,0H0A7.544,7.544,0,0,0,7.508,7.547Z",
    transform: "translate(1285.768 12358.003) rotate(-164.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M452.236,522.532h6.171l2.936-23.945h-9.108Z",
    transform: "translate(879.646 11829.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M446.324,542.372h-11.9v7.538h19.393a7.516,7.516,0,0,0-7.493-7.538Z",
    transform: "translate(896.136 11808.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M722.9,444.313a5.042,5.042,0,0,1-7.747.465l-16.4,7.422,1.492-9.282,15.348-5.625a5.066,5.066,0,0,1,6.755.244,5.142,5.142,0,0,1,.555,6.777Z",
    transform: "translate(616.419 11774.071)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M738.985,498.219c5.154,0,10.489-.772,14.973-3.069a19.423,19.423,0,0,0,9.92-11.933c2.336-7.443-.609-14.755-3.458-21.827-1.765-4.382-3.433-8.521-3.866-12.6l-.151-1.448c-.674-6.505-1.256-12.124-4.478-14.231-1.67-1.092-3.916-1.155-6.866-.191l-27.705,9.054,1.019,52.91.168.057A73.19,73.19,0,0,0,738.985,498.219Z",
    transform: "translate(566.256 11775.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M763.1,398.251s-13.59-4.051-24.159-2.532c0,0,6.04,33.42,4.026,44.559s34.981,4.3,27.431-6.329l-2.517-12.659a8.482,8.482,0,0,0,.5-11.14Z",
    transform: "translate(548.7 11794.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M721.309,480.027l16.749-3.159L732.21,431.6c-.393-1.264-9.451-29.948-13.565-31.5a69.892,69.892,0,0,0-9.143-2.556l-.6-.12,3.358,5.068,13.37,32.232Z",
    transform: "translate(597.174 11793.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M747.91,586.937l21.64-3.628L757.406,533.42l-18.071-68.225-.178,1.211c-.014.09-1.7,9-26.752,5.048l-.22-.035-.061.216-30.276,107.62,24.658,4.134L729,504.871Z",
    transform: "translate(579.3 11759.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M810.733,486.931l-.014-.383c-.015-.425-1.5-42.723-1.007-59.734a94.341,94.341,0,0,0-5.049-32l-.045-.119-.121-.035c-7.107-2.042-13.272,4.054-13.333,4.115l-.087.087,2.024,16.8-8.665,61.088Z",
    transform: "translate(486.484 11794.744)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 12.362,
    cy: 12.437,
    rx: 12.362,
    ry: 12.437,
    transform: "translate(1285.915 12159.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M776.979,346.062a13.394,13.394,0,0,0-13.338-13.419h-2.517a13.393,13.393,0,0,0-13.338,13.419v.253h5.318l1.814-5.11.363,5.11h2.748l.915-2.578.183,2.578h17.85Z",
    transform: "translate(538.683 11825.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M794.344,366.887a2.256,2.256,0,0,0,.177-2.383c-2.667-5.1-6.4-14.533-1.445-20.348l.356-.418H779.044V365.47l13.071,2.32a2.307,2.307,0,0,0,.4.036A2.252,2.252,0,0,0,794.344,366.887Z",
    transform: "translate(505.15 11819.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M540.236,196.537a67.67,67.67,0,0,1,94.392,6.575A68.664,68.664,0,0,1,631,298.231a67.666,67.666,0,0,1-94.615-.725l-83.359,70.762a6.236,6.236,0,0,1-8.825-.744,6.326,6.326,0,0,1,.739-8.879l.009-.008,83.359-70.762A68.66,68.66,0,0,1,540.236,196.537Zm5.374,84.525a50.7,50.7,0,0,0,71.747,6.115A51.436,51.436,0,0,0,623.436,215a50.7,50.7,0,0,0-71.747-6.115h0A51.436,51.436,0,0,0,545.61,281.062Z",
    transform: "translate(817.188 11900.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M533.89,324.124a51.441,51.441,0,0,0,8.64-68.859q1.46,1.479,2.823,3.1a51.436,51.436,0,0,1-6.078,72.18,50.7,50.7,0,0,1-71.747-6.115q-1.36-1.621-2.561-3.321A50.694,50.694,0,0,0,533.89,324.124Z",
    transform: "translate(900.655 11863.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M806.024,479.989a5.037,5.037,0,0,1-4.2-.843,5.1,5.1,0,0,1-2.054-3.781l-17.331-4.839,7.045-6.179,15.378,5.543a5.123,5.123,0,0,1,1.161,10.1Z",
    transform: "translate(488.284 11760.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M829.578,447.115l1.055-10.08L816.156,429l9.438-11.494-1.54-12.912-3.835-1.654-.119.154c-1.809,2.339-17.669,22.928-17.669,25.473,0,2.614,3.034,10.291,7.186,12.379,4,2.014,19.041,5.929,19.679,6.1Z",
    transform: "translate(457.527 11790.451)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M572.27,728.31H764.034a.506.506,0,0,0,0-1.013H572.27a.506.506,0,0,0,0,1.013Z",
    transform: "translate(639.719 11630.336)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchImage);
export default __webpack_public_path__ + "static/media/search-image.26d77b9ad81d00bdabce2352e2d50c26.svg";
export { ForwardRef as ReactComponent };